import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'ols-payment-processing',
    templateUrl: './payment-processing.component.html',
    styleUrls: ['./payment-processing.component.scss'],
})
export class PaymentProcessingComponent {
    constructor(public dialogRef: MatDialogRef<PaymentProcessingComponent>) {
        dialogRef.addPanelClass('ols-payment-processing-panel');
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
